import { useState, useEffect } from "react";

interface StateType {
  direction: "up" | "down";
  top: boolean;
  bottom: boolean;
  distanceFromTop: number;
  distanceFromBottom: number;
}

export default function useScroll() {
  const [scroll, setScroll] = useState<StateType>({
    direction: "up",
    top: true,
    bottom: false,
    distanceFromTop: 0,
    distanceFromBottom: 0,
  });

  useEffect(() => {
    let lastScroll = window.scrollY;

    const handleScroll = () => {
      const currentScrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const distanceFromTop = currentScrollPosition;
      const distanceFromBottom =
        documentHeight - (currentScrollPosition + windowHeight);

      setScroll({
        direction: currentScrollPosition > lastScroll ? "down" : "up",
        top: currentScrollPosition === 0,
        bottom: distanceFromBottom <= 0,
        distanceFromTop,
        distanceFromBottom,
      });

      lastScroll = currentScrollPosition;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return scroll;
}
